/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.xtra-space[_ngcontent-%COMP%]{min-height:100px;display:block;position:relative;background:#a7a495}.xtra-space[_ngcontent-%COMP%]   .breadCrumb[_ngcontent-%COMP%]{padding-top:80px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvaGVhZGVyL2JyZWFkY3J1bWIvYnJlYWRjcnVtYi5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvaGVhZGVyL2JyZWFkY3J1bWIvYnJlYWRjcnVtYi5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/header/breadcrumb/breadcrumb.component.css.shim.ngstyle.ts